import { Component, Host, h, Prop } from '@stencil/core';

import flagsSrc from 'intl-tel-input/build/img/flags@2x.png'

const flagStyles = {
  backgroundImage: `url(${flagsSrc})`
}

@Component({
  tag: 'anchor-country-code',
  styleUrl: 'country-code.scss',
  shadow: true,
})
export class CountryCode {
  @Prop() name: string;

  @Prop() iso: string;

  @Prop() dialCode: string;

  @Prop() showName: boolean = true;

  render() {
    return (
      <Host>
        <div class="anchor-c-country-code">
          <div class="iti__flag-box">
            <div class={`iti__flag iti__${this.iso}`} style={flagStyles}></div>
          </div>
          <span class="iti__dial-code">+{this.dialCode}</span>
          {this.showName && <span class="iti__country-name">{this.name}</span>}
        </div>
      </Host>
    );
  }
}
